import { RUNTIME_ROOT_SELECTOR } from './modules/dom.js';
import { initializeSpecialtyCarousels } from './modules/specialty-carousel.js';
import { initializeCountUps } from './modules/count-up.js';
import { initializeRails } from './modules/rail.js';
import { initializeHeroSelector } from './modules/hero-selector.js';
import { initializePortalTabs } from './modules/portal-tabs.js';
import { initializeDrawers } from './modules/drawer.js';
import { initializeMegaMenus } from './modules/mega-menu.js';
import { initializeLoadReveals } from './modules/scroll-reveal-on-load.js';
import { initializeProductFilter } from './modules/product-filter.js';
import { initializeInsightsFilter } from './modules/insights-filter.js';
import { initializeTimelines } from './modules/timeline.js';
import { initializeCardDecks } from './modules/card-deck.js';
import { initializeMarquees } from './modules/marquee.js';

const ROOT_MODULES = [
  initializeSpecialtyCarousels,
  initializeCountUps,
  initializeRails,
  initializeHeroSelector,
  initializePortalTabs,
  initializeProductFilter,
  initializeInsightsFilter,
  initializeTimelines,
  initializeCardDecks,
  initializeMarquees,
];

// One module that throws must not stop the others.
function run(initialize, ...args) {
  try {
    initialize(...args);
  } catch (error) {
    console.error('[berlin-site]', error);
  }
}

function initializeRuntime() {
  run(initializeDrawers, document);
  run(initializeMegaMenus, document);
  run(initializeLoadReveals);
  for (const root of document.querySelectorAll(RUNTIME_ROOT_SELECTOR)) {
    for (const initialize of ROOT_MODULES) run(initialize, root);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeRuntime, { once: true });
} else {
  initializeRuntime();
}
